import Vue from 'vue';
import { playRewardedAd } from 'js/crossword/sdk/playRewardedAd';
import { trackRevealAd } from 'js/tracking/track';
import { Provider, RevealType } from 'js/crossword/types';
import PopupButtons from "./PopupButtons";
import PopupContainer from "./PopupContainer";

export default Vue.extend({
  inject: [Provider.LOCALIZATION],
  props: {
    type: String,
  },
  methods: {
    watchAd() {
      playRewardedAd().then(() => {
        trackRevealAd(this.type as RevealType);
        this.$emit('reveal', this.type);
        this.$emit('close');
      });
    },
  },
  render() {
    return (
      <PopupContainer
        customClasses={["popup--revealAdPopup"]}
        handleClose={() => this.$emit("close")}
      >
        <div class='adPopup--content-wrapper'>
          <div>
            <img class='adPopup--icon' src='images/Bulb_Icon.svg' />
          </div>

          <div style='margin-bottom: 0.1em'>
            {this.localization.get("You have already used")} <b>
              {this.localization.get("3 hints")}
            </b>
          </div>

          <div style='margin-bottom: 1.3em'>
            <b>
              {this.localization.get("Watch an ad")}
            </b> {this.localization.get("to get another hint.")}</div>
        </div>

        <PopupButtons buttons={[{
          label: this.localization.get("Get a hint"),
          onClick: this.watchAd,
        }]} />
      </PopupContainer>
    );
  },
});
